import { omit } from "lodash";
import { DEFAULT_EVENT_IMAGE_URL } from "../../../utils/constants";
import {
  deepEmptyStringsToUndefined,
  formatDate,
} from "../../../utils/helpers";
import { CreateEvent } from "./event.types";

export const buildEventRequestBody = (payload: Partial<CreateEvent>) => {
  const { soundtrackUrl, ...requestPayload } = payload;

  return deepEmptyStringsToUndefined({
    ...requestPayload,
    startDate: ["", undefined].includes(payload.startDate)
      ? undefined
      : `${formatDate(payload.startDate, "YYYY-MM-DD")}T00:00:00Z`,
    endDate: ["", undefined].includes(payload.endDate)
      ? undefined
      : `${formatDate(payload.endDate, "YYYY-MM-DD")}T00:00:00Z`,
    image: payload.image === "" ? DEFAULT_EVENT_IMAGE_URL : payload.image,
    tickets: payload?.tickets
      ? payload.tickets.map((t) => omit(t, ["quantity"]))
      : undefined,
  });
};
